export default __webpack_public_path__ + "static/media/download_small_white.acfdd58b.svg";